import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography } from '@mui/material';
import { DragVerticalIcon } from '@ui/assets/custom-icons/drag-vertical-icon';
import { Iconly } from 'react-iconly';
const FaqRowItem = ({ question, answer, isLoading = false, dragHandleProps, onDelete, onEdit, onClick }) => {
    return (_jsxs(Box, { display: 'flex', gap: 0.5, padding: '12px 0px 12px 48px', position: 'relative', onClick: onClick, sx: { cursor: 'pointer' }, children: [_jsx(Box, { sx: {
                    position: 'absolute',
                    left: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'grab',
                    touchAction: 'none'
                }, ...dragHandleProps, children: _jsx(DragVerticalIcon, {}) }), _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', children: [_jsxs(Box, { display: 'flex', gap: 0.5, flexDirection: 'column', children: [_jsx(Box, { children: _jsx(Typography, { variant: 'subtitle1', children: question }) }), _jsx(Box, { sx: { typography: 'body2', '& a': { color: 'primary.main' } }, dangerouslySetInnerHTML: { __html: answer }, onClick: (e) => {
                                    if (e.target.closest('a'))
                                        e.stopPropagation();
                                } })] }), _jsxs(Box, { display: 'flex', gap: 0.5, alignItems: 'center', children: [_jsx(IconButton, { color: 'error', onClick: (event) => {
                                    event.stopPropagation();
                                    onDelete?.();
                                }, children: _jsx(Iconly, { name: 'Delete', set: 'curved' }) }), _jsx(IconButton, { color: 'inherit', onClick: (event) => {
                                    event.stopPropagation();
                                    onEdit?.();
                                }, children: _jsx(Iconly, { name: 'Edit', set: 'curved' }) })] })] })] }));
};
export default FaqRowItem;
